import React, { useEffect, useState } from 'react'
import Header from '../../comps/Header';
import Footer from '../../comps/Footer';
import { user_Profile } from '../../api/Auth';
import { useNavigate } from 'react-router-dom';

const User_Profile = () => {
    const navigate = useNavigate();
    const [get_user_profile, set_Get_User_Profile] = useState([]);

    // <---------- User Authentciation token's ------------>
    const token = localStorage.getItem("token");
    const headers = {
        "Authorization": `Bearer ${token}`
    }

    // <-------------- fetch the user profile -------------->
    useEffect(() => {
        const handle_get_user_profile = async () => {
            try {
                const response = await user_Profile(headers);
                set_Get_User_Profile(response?.data?.user)
            }
            catch (error) {
                console.log("error", error)
            }
        }
        handle_get_user_profile();
    }, [])
    console.log("get_user_profile", get_user_profile)

    return (
        <>
            {/*  */}
            {/* <Header /> */}
            <div className="max-w-md mx-auto bg-white rounded-xl p-6 border border-gray-200 mb-10">
                {/* User Info */}
                <h2 className="text-2xl font-bold text-gray-800 text-center">{get_user_profile?.name}</h2>
                <div className="mt-4">
                    <p className="text-gray-600">
                        <span className="font-semibold">Email:</span> {get_user_profile?.email}
                    </p>
                    <p className="text-gray-600">
                        <span className="font-semibold">Phone:</span> {get_user_profile?.phone}
                    </p>
                </div>

                {/* Edit Profile Button */}
                <div className="mt-6 flex justify-center">
                    <button className="px-6 py-2 text-white bg-amber-600 rounded-lg hover:bg-stone-1000 transition-all" 
                   onClick={() => {navigate("/user-profile-edit", { state: { get_user_profile: get_user_profile } });
                }}>
                        Edit Profile
                    </button>
                </div>
            </div>
            {/*  */}
            {/* <Footer /> */}
        </>
    )
}

export default User_Profile
